import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Input } from '@fx-ui/fine-design';
import { getImgCaptcha } from '../../../apis';
import { platformIntl } from '../../../constants';

interface ICaptchaProps {
    value: string;
    onChange: (v: string) => void;
    className?: string;
    style?: React.CSSProperties;
    placeholder?: string;
    error?: boolean;
    refreshToken?: number;
    [key: string]: any;
}

interface ICaptchaData {
    data: string;
}

const Captcha: React.FunctionComponent<ICaptchaProps> = (props) => {
    const {
        value,
        onChange,
        className,
        style,
        placeholder = platformIntl.get('captcha.img.placeholder'),
        error,
        refreshToken
    } = props;
    const [imgSrc, setImgSrc] = useState('');

    useEffect(() => {
        refresh();
    }, []);

    useEffect(() => {
        if (refreshToken) {
            refresh();
        }
    }, [refreshToken]);

    const svg2DataUrl = (svgString: string) => {
        if (svgString) {
            // 使svg支持拉伸（svg默认锁定了宽高比）
            const canResizeSvg = svgString.replace('<svg', '<svg preserveAspectRatio="none meet"');
            /**
             * 1. svg在使用dataUrl展示的时候必须编码才能正常显示；
             * 2. 可以使用btoa转换为base64编码也可以直接encodeURIComponent转换为utf8编码；
             * 3. 不建议base64编码，因为性能有损耗，且编译后体积增大。
             */
            return 'data:image/svg+xml;charset=utf8,' + encodeURIComponent(canResizeSvg);
        }
        return svgString;
    };

    const refresh = () => {
        getImgCaptcha().then((res: { data: ICaptchaData }) => {
            setImgSrc(svg2DataUrl(res.data.data || ''));
        });
    };

    const renderImg = () => {
        return (
            <div className="img-wrapper" onClick={refresh}>
                {imgSrc && (
                    <div className="img-base" style={{ backgroundImage: `url(${imgSrc})` }} />
                )}
            </div>
        );
    };

    return (
        <Input
            className={classNames('fx-captcha', className)}
            style={style}
            value={value}
            onChange={(v) => onChange(v)}
            placeholder={placeholder}
            inputState={error ? 'error' : undefined}
            afterAddon={renderImg()}
        />
    );
};

export default Captcha;
